import { findFormsWidgetFormIds } from './formsWidgetData.util';
import { hasSameFormIds } from './formsWidgetConfig.util';
import { replaceFormsWidgetFormIds } from './formsWidgetSection.util';

/**
 * Restores one Forms widget's previous form ids after a failed PATCH. Rolls back only while
 * the widget still shows this mutation's optimistic ids, so a newer add/remove made while the
 * request was in flight is not clobbered.
 *
 * @param {object[]} sections - Current plan sections
 * @param {string} widgetId
 * @param {{ optimisticFormIds: string[], previousFormIds: string[] }} snapshot
 * @returns {object[]} Rolled-back sections, or the same sections when a newer change won
 */
export const rollbackFormsWidgetFormIds = (sections, widgetId, { optimisticFormIds, previousFormIds }) =>
  hasSameFormIds(findFormsWidgetFormIds(sections, widgetId), optimisticFormIds)
    ? replaceFormsWidgetFormIds(sections, widgetId, previousFormIds)
    : sections;
